import React, { lazy } from 'react'
import { Route, Switch } from 'react-router-dom'
import PrivateRoute from './HOC/PrivateRoutes/index'
import PublicRoutes from './HOC/PublicRoutes/index'
import { getAuthToken } from 'utils/common-services/sessionStorage.service'
import { crashRoutesList, fastGameRoutesList, slotsRoutesList } from './routesList'
import { ROUTE_PATHS } from 'utils/constants/index'
import useOperatorAuthentication from 'hooks/useOperatorAuthentication'
const NotFoundComponent = lazy(() => import('components/layout/404/index'))
const InActiveGameComponent = lazy(() => import('components/layout/InActiveGame/index'))

const RouteRenderer = (route) => {
  const { component: Component, child: Child, isHeader, isFooter } = route
  const isAuthenticated = getAuthToken()

  return (
    route?.isPrivate
      ? <PrivateRoute isAuthenticated={isAuthenticated} Component={Component} child={Child} isHeader={isHeader} isFooter={isFooter} />
      : <PublicRoutes isHeader={isHeader} Component={Component} child={Child} isFooter={isFooter} />

  )
}
const CustomRoutes = () => {
  // custom-hook to manage login operations
  useOperatorAuthentication()
  return (
    <>
      <Switch>
        {
          crashRoutesList.map((route) => (
            <Route path={route.path} key={route.path} exact render={() => RouteRenderer(route)} />
          ))
        }{
          fastGameRoutesList.map((route) => (
            <Route path={route.path} key={route.path} exact render={() => RouteRenderer(route)} />
          ))
        }
        {
          slotsRoutesList.map((route) => (
            <Route path={route.path} key={route.path} exact render={() => RouteRenderer(route)} />
          ))
        }
        <Route path={ROUTE_PATHS.inActiveGame} component={() => <InActiveGameComponent />} />
        <Route component={() => <NotFoundComponent />} />
      </Switch>
    </>
  )
}

export default CustomRoutes
